export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '0d31f69a-cab2-4497-9c9a-b80b9a94c3f0',
      authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
      redirectUri: 'https://euwutaxtc2wap01.azurewebsites.net',
    },
  },
  graphConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  apiConfig: {
    baseUrl: 'https://euwutaxtc2wap02.azurewebsites.net/api',
    scopes: ['api://0d31f69a-cab2-4497-9c9a-b80b9a94c3f0/.default'],
  },
  fileUpload: {
    documentFileMaxSize: 10 * 1024 * 1024,
    requestProcessorFileMaxSize: 5 * 1024 * 1024,
  },
};
